import { render, staticRenderFns } from "./AddBlock.vue?vue&type=template&id=7a8304f0&scoped=true&"
import script from "./AddBlock.vue?vue&type=script&lang=js&"
export * from "./AddBlock.vue?vue&type=script&lang=js&"
import style0 from "./AddBlock.vue?vue&type=style&index=0&id=7a8304f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8304f0",
  null
  
)

export default component.exports